/**
 * CM
 * 보안 정책
 * 위협 정책
 * TAMS Snort Store
 *
 * @since 2021-11-29
 * @author wj_tams_dev04
 */

import {SecutiryPolicyApiPrefix} from '~/utils/restApi'

const urlPrefix = `${SecutiryPolicyApiPrefix}/ext-dist/tams/snort`

export const state = () => ({
  snortList: [], // 스노트 프로파일 리스트
  snortRuleList: [] // 스노트 프로파일별 룰 리스트
})

export const mutations = {
  init (state) {
    state.snortList = []
    state.snortRuleList = []
  },
  initSnortList (state, snortList) {
    state.snortList = snortList
  },
  initSnortRuleList (state, snortRuleList) {
    state.snortRuleList = snortRuleList
  }
}

export const actions = {
  // 스노트 프로파일 리스트 획득
  async getSnortList ({commit}, {loading = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(`${urlPrefix}/profile`, {loading})
      if (code === 'ok') {
        commit('initSnortList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // 스노트 프로파일 추가
  async addSnort ({commit, state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$post(`${urlPrefix}/profile`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // 스노트 프로파일 수정
  async updateSnort ({state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$put(`${urlPrefix}/profile/${param.ips_tams_snort_prf_id}`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // 스노트 프로파일 삭제
  async deleteSnort ({state}, snortID) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$delete(`${urlPrefix}/profile/${snortID}`, {successAlert: false, loading: false})
      if (code !== 'ok') {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = { code: 'nok', reason: e }
    }
    return res
  },
  // 스노트 프로파일 동기화 수정
  async setSnortUseYn ({state}, {prfID, param, loading = false, successAlert = false} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$put(`${urlPrefix}/profile/${prfID}/use`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // 스노트 정책 리스트 조회
  async getSnortRuleList ({commit}, {prfID, loading = true}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(`${urlPrefix}/rule/${prfID}`, {loading})
      if (code === 'ok') {
        commit('initSnortRuleList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // 스노트 정책 리스트 조회
  async getSnortRule ({commit}, {prfID, ruleID, loading = true}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(`${urlPrefix}/rule/${prfID}/${ruleID}`, {loading})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // 스노트 정책 추가
  async addSnortRule ({commit, state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$post(`${urlPrefix}/rule/${param.ips_tams_snort_prf_id}`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // 스노트 정책 수정
  async updateSnortRule ({state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$put(`${urlPrefix}/rule/${param.ips_tams_snort_prf_id}/${param.ips_tams_snort_id}`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // 스노트 정책 삭제
  async deleteSnortRule ({state}, payload) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$delete(`${urlPrefix}/rule/multi`, {data: {ips_tams_snort_item: payload}}, {successAlert: false, loading: false})
      if (code !== 'ok') {
        res = {code: 'nok', reason: result.msg}
      }
      res = result
    } catch (e) {
      res = { code: 'nok', reason: e }
    }
    return res
  },
  // 스노트 정책 배치 입력
  async addSnortRuleBatch ({commit, state}, {prfId, formData, loading = true, successAlert = false} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$post(
        `${urlPrefix}/rule/batch/${prfId}`,
        formData, {loading, successAlert, headers: {'Content-Type': 'multipart/form-data'}})
      if (code === 'ok') {
        res.result = result
        if (result.ips_tams_snort_res) {
          res = {code: 'nok', reason: result.ips_tams_snort_res}
        }
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // 스노트 정책 사용여부 수정
  async setSnortRuleUseYn ({state}, {prfID, ruleID, param, loading = true, successAlert = false} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$put(`${urlPrefix}/profile/${prfID}/${ruleID}/use`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  // 스노트 설정 취소/적용
  async finalCommand ({state}, type) {
    let res = {code: 'ok'}
    const apiUri = `${urlPrefix}/${type}`,
      axiosConfig = (type === 'apply') ? { applyMsg: true } : { cancelMsg: true }
    try {
      const result = await this.$axios.$put(apiUri, void 0, axiosConfig)
      res = result
    } catch (e) {
      res = { code: 'nok', result: {msg: e} }
    }
    return res
  }
}
